import React from 'react';
import './RegisterBg.css';

const RegisterBg = () => {
  return (
    <main>
      <div className="jumbo"></div>
    </main>
  );
};

export default RegisterBg;
